// extracted by mini-css-extract-plugin
export default {"pageWrap":"Zb-z","fullWidth":"_b-z","heading":"ac-z","fullBleed":"bc-z","hidden":"cc-z"};